export const huboPromiseFieldList = [
  '사드배치',
  '종전선언',
  '전술핵 재배치',
  '한반도 비핵화∙남북 대화',
  '개성공단',
  '국방 개혁',
  '한일 위안부 협의',
  '경제 정책 방향',
  '정부 주도 일자리 창출',
  '비정규직',
  '임금 격차',
  '최저 임금',
  '증세',
  '복지',
  '가계 부채',
  '법인세',
  '금융 환경',
  '고소득자 증세',
  '부동산 보유세',
  '재벌 개혁',
  '코로나 경제 활성화',
  '복지 예산',
  '아동 수당',
  '보육 정책',
  '실생활',
  '누리과정 예산',
  '육아 휴직',
  '기초연금',
  '의료',
  '코로나 피해 지원',
  '교육 과정',
  '청소년 관련 법',
  '대입 정책',
  '외고∙자사고∙국제고',
  '교육부 개혁',
  '미세먼지 측정 기준',
  '미세먼지 국내 해외',
  '미세먼지 비교',
  '탄소 배출',
  '산업 구조 개편',
  '신산업 분야',
  '창업 지원',
  '가계통신비',
  '개헌',
  '검찰개혁',
];

export const huboPromiseFieldListTest = [
  [
    {
      title: '외교·안보·국방',
      list: ['사드배치', '종전선언', '한반도 비핵화∙남북 대화', '개성공단', '국방 개혁', '한일 위안부 협의'],
      promise: [
        {
          id: '1',
          promise: [
            '<p>-</p>',
            '<p>-한반도 평화 경제 체제 수립</p><p>-한반도 평화 프로세스 계승</p><p>-유엔 제재 면제 사업 우선 추진</p>',
            '<p>-文정부 ‘한반도 운전자론’ 계승</p><p>-10·4 선언 이행</p><p>-남북 합의 국회 비준 추진</p><p>-이산가족 상봉·고향 방문 추진</p><p>-조건부 제재 완화와 단계적 동시 행동 추진</p>',
            '<p>-개성공단 재개 </p><p>-철도·도로 연결 및 현대화 위해 유엔에 제재 면제 신청</p>',
            '<p>-스마트 강군 건설</p><p>-무기 체계 첨단화, 자주 국방 역량 확충</p><p>-육·해·공·해병 준4군 체제로 개편</p><p>-선택적 모병제 도입, 간부 중심 병력 구조 전환 등 군 구조 합리적 개선</p><p>-사병 월급 200만 원 추진, 소인실 생활관 개편 등 장병 복무 여건 개선</p><p>-병사 통신 요금 반값으로 인하</p><p>-군 복무 청년 상해 보험 제도 전국 확대</p><p>-학점 인정제 모든 대학 적용, 군경력 호봉 인정 의무화</p><p>-동원 예비군 3년으로 단축, 훈련 보상비 일 20만 원 지급</p><p>-한미동맹 잠수함 건조 추진</p><p>-대통령 직속 국방혁신 기구 설치</p>',
            '<p>-</p>',
          ],
        },
        {
          id: '2',
          promise: [
            '<p>-사드 기지 정상화</p><p>-한미 동맹 재건 위해 한미 연합 연습, 야외 기동 훈련 정상 시행</p><p>-자위권 차원에서 직접 사드 구매, 추가 배치해 수도권과 경기 북부 지역 확실하게 보호</p>',
            '<p>-북한 비핵화 실질적 진전 없으므로 시기상조</p><p>-북한 비핵화 불가역적 진전있을 시 협력 관계 수립</p>',
            '<p>-한·미 확장억제력 확충해 북한 핵·미사일 능력 무력화</p><p>-판문점에 남북미 상설 연락사무소 설치</p><p>-비핵화 이후 대비해 남북 공동 경제 발전 계획 추진</p><p>-남북간 방송 통신 개방, 청년 교류, 문화 교류 등 확대</p><p>-북한의 핵 개발 시설 전면 사찰 허용 등 실질적 비핵과 촉구</p><p>-대북 인도적 지원과 대화의 문 상시 개방, 북한 인권 재단 설립</p><p>-침략적 도발 행위 확실시 한반도 평화 위해 치명적 타격 가능</p>',
            '<p>-</p>',
            '<p>-4차 산업혁명 기반으로 국방혁신 4.0 주도</p><p>-인공지능 기반 무인 및 로봇 전투 체계를 조기에 도입</p><p>-과학 기술 전문 전투 요원 모병 확대, 여성 인력 참여 확대</p><p>-사이버, 우주, 핵 공격 억제 가능한 제2의 창군 수준으로 군 재설계</p><p>-군 복무기간 원격 강좌와 학점 부여, 창업 교육 실시</p><p>-병사 월급 200만원 지급 등 병영 체계 개선</p><p>-군사 시설과 훈련장 지역 단위 통합, 불필요한 군사 시설 보호 구역 해제해 민군 상생 복합 타운 건설</p><p>-병영 의무 이행에 대한 합당한 보상 대책 강구</p><p>-AI 입대 코디네이터 도입해 입영 예정자 안내</p><p>-입영 시기, 특기 등 선택할 수 있도록 입영 대상자 선택권 확대</p><p>-입대 선호 시기 입영 인원 확대</p><p>-병역 진로 설계 센터 전국 설치, 찾아가는 상담 서비스 확대</p><p>-취업 맞춤 특기병 활성화하고 교육·병역·취업 연계 체계 강화</p>',
            '<p>-그랜드바겐 방식으로 접근, 다양한 문제 한 테이블에 놓고 협상해야</p><p>-김대중-오부치 선언 정신 이어 한일 미래 발전 위해 협력, 과거사 논의</p><p>-경제·안보 협력 구축해 신뢰 쌓으면 일본이 사과하고 배상할 것, 미래 지향적 관계 확립 필요</p>',
          ],
        },
        {
          id: '3',
          promise: [
            '<p>-</p>',
            '<p>-평화선언 통해 비핵화 이뤄내야</p>',
            '<p>-</p>',
            '<p>-</p>',
            '<p>-국방 개혁 3.0</P><p>-전장(戰場) 무인화‧네트워크화</P><p>-원자력추진 잠수함 건조 추진</P><p>-징병·모병 혼합제 등 한국형 모병제 도입</P><p>-병사 최저 임금 보장</P> <p>-공무상 상해에 대해 국가가 책임</p><p>-성 주권 확립, 성적자기결정권 존중</P><p>-한일 양국의 미래 세대를 위한 화합 필요</P>',
            '<p>-</p>',
          ],
        },
        {
          id: '4',
          promise: [
            '<p>-대중국 3불 정책(추가 사드 배치·미국 중심의 미사일 방어 체계·한미일 군사 협력) 폐지</p><p>-수도권 보호하기 위해 사드 추가 배치보다 한국형 미사일 방어 체계 먼저 구축해야</p><p>-사드 추가 배치·미국 미사일 방어 체계 참여·한미일 군사 동맹화 3가지 않는 3불 정책 반대</p>',
            '<p>-종전 선언에 목 매기 보다 경계 태세 다잡고 장병 격려</p><p>-종전 선언은 북한 비핵화의 한 과정</p><p>-북한 비핵화 의지 밝히고 행동하지 않는 이상 종전 선언하지 않을 것</p>',
            '<p>-비핵화 전 종전 선언은 재앙</p> <p>-한미 동맹에 기반한 다층 방어 체계 재구축 필요</p><p>-핵 잠수함 조기 확보, 우주 미사일 사령부 창설 필요</p><p>-안보 위협 행위에 단호히 대처하며 남북 대화</p>',
            '<p>-비핵화 진전으로 북한에 투자 재개될 시 다국가 참여하는 국제 컨소시엄으로 구성</p>',
            '<p>-자기 계발에 집중할 수 있는 병영 문화 형성</p><p>-준모병제 도입</p><p>-전문 부사관 군 병력 50%까지 확대</p><p>-AI, 과학 시스템으로 보초 임무 대체</p><p>-전역 장병 1000만원 사회진출지원금 제공</p> <p>-민간인 국방부 장관 임명 법률 추진해 전혁한 지 7년 지난 민간인 장관으로 임명</p><p>-국방부 개방형 직위 전역 후 3년 지나야 임명 가능하도록 체제 개선</p>',
            '<p>-법원 판결 집행 보류하고 양국 정부 대화로 해</p>',
          ],
        },
      ],
    },
    {
      title: '경제·복지',
      list: [
        '경제 정책 방향',
        '지역 주도 일자리 창출',
        '정부 주도 일자리 창출',
        '비정규직',
        '최저 임금',
        '증세',
        '복지',
      ],
      promise: [
        {
          id: '1',
          promise: [
            '<p>-중소·벤처기업 7대 공약 통해 대·중소기업 상생 유도</p><p>-코리아 디스카운트 해소, MSCI 선진국 지수 편입</p><p>-현장 중심 지원으로 소상공인·전통시장 경쟁력 강화</p><p>-농업 경쟁력 위해 GMO 완전 표시제 도입</p><p>-5개 수도·2개 특별자치시 통해 국가 균형 발전 유도</p><p>-재개발·재건축 신속협의제 도입, 공공 재개발 활성화 </p><p>-공공주택 다양하게 공급, 민간 주택 분양가 인하 추진</p><p>-전국에 311만 호 주택 공급, 주택 공급 가격 반값 조정</p><p>-전세 수요자 피해 해소, 전세 사기 근절 </p><p>-KTX, SRT 고속철도 통합</p><p>-연말 정산 절차 간소화, 공제 금액 상향, 청년 취업자 특별 공제 도입</p><p>-대통령 직속 기획예산처 신설</p>',
            '<p>-135조 규모 디지털 전환 투자, 일자리 200만 개 창출</p><p>-전통 산업→디지털 산업 전환 지원</p><p>-유니콘 기업 100개 육성</p><p>-프리랜서·플랫폼 종사자·소상공인협동조합 성장 지원 </p><p>-지역 사회 균형 발전 실현 </p>',
            '<p>-플랫폼 가맹 사업자 단체결성권·협상권 보장</p><p>-플랫폼 수수료 공개·공공 플랫폼 확대·플랫폼 사회적 대화 기구 설치</p>',
            '<p>-비정규직 공정수당 공공·민간 분야 확대 </p>',
            '<p>-</p>',
            '<p>-자동차세 부과 체계를 자동차 가격·CO2 배출 기준으로 변경</p><p>-소형차·전기차·수소차 세금 증가하지 않도록 설계</p>',
            '<p>-데이트폭력·스토킹 등 젠더폭력 근절</p><p>-임기 내 기본주택 250만 호 공급</p><p>-중소기업 성장 위해 복지 향상</p><p>-청소·경비 노동자 휴게 시설 마련 의무화</p><p>-장애인 유형·정도 맞춤 서비스, 독립 지원</p><p>-전 국민 교통 기본권 보장</p><p>-지역사회 통합돌봄서비스 전국 확대</p><p>-여성가족부→성평등가족부 개편</p><p>-임차상인 임대료 부담 완화</p><p>-동물 복지 전담 부서 설치</p><p>-주택 실수요자 취득세 부담 완화</p> <p>-월세 주거 국민 지원 확대</p><p>-노인 임플란트 지원</p><p>-섬 주민 월 5회 천원 여객선, 명절 천원 여객선 운영</p><p>-모든 버스·지하철에 5G 와이파이 설치</p><p>-스포츠 포인트 지역 화폐로 환급</p><p>-여성 청소년 생리 용품 지원</p><p>-어르신 운전면허증 반납시 지역 화폐로 보상 지급</p><p>-의료기관·공공기관에 수어 통역사 배치</p>',
          ],
        },
        {
          id: '2',
          promise: [
            '<p>-경제 성장과 함께 국민 삶의 질 높이는 행복 경제</p><p>-민간주도 일자리, 기업투자 일자리로 성장 패러다임 전환</p><p>-기업이 성장할 수 있도록 자유와 창의 보장, 제도적 여건 마련</p> <p>-4차 산업 혁명 시대에 민간이 자율 생산 활동하도록 정부가 인프라 구축하고 제도 설계·관리</p>',
            '<p>-기업 주도 일자리 창출</p><p>-융합 산업 분야 중심 신산업 생태계 조성, 창의형 일자리 창출</p><p>-변화하는 산업 수요에 맞춰 연령대별 맞춤 일자리 제공</p><p>-중견·중소기업에 지원으로 피터팬 증후군 해소</p><p>-ICT 산업과 혁신 벤처 육성</p>',
            '<p>-정부 일방적인 주도 아닌 노사간 자율적인 대타협 필요 </p>',
            '<p>-근로 장려 세제 소득 및 재산 요건 완화, 급여율 개선</p>',
            '<p>-고용주와 근로자 모두 감안해 최저임금 점진적으로 인상</p>',
            '<p>-증세 아닌 지출 분야 구조 조정</p><p>-경제 성장 통해 세원 확보</p><p>-간접세 위주의 증세 지양</p>',
            '<p>-국민 기초 생활 보장 생계 급여 확대</p> <p>-취약 계층에 한한 긴급 복지 지원 제도를 국민안심지원제도로 확대 개편</p><p>-경제·사회 도약적으로 성장시켜 양극화 극복, 지속 가능한 복지 실현</p>',
          ],
        },
        {
          id: '3',
          promise: [
            '<p>-플랫폼 독점방지법 재정, 플렛폼기업 주4일제 우선 도입 등 플랫폼 경제 민주화</p><p>-곡물자급률 30% 법정화, 농어민 월 30만 원 기본 소득 지급, 농어업 노동 재해 보상 보험 도입 등 농산어촌 녹색대전환</p><p>-주당 16시간 근로 보장, 공공기관 청년 고용 의무 할당제 상향</p><p>-20세 모든 청년 청년기초자산 도입, 21~29세 청년 매월 300만 원 지급</p><p>-저소득층 생계비 대출 햇살론유스 이자 전액 지원, 상환 기관 30년으로 부담 완화</p><p>-근로기준법 5인 미만 사업장으로 확대 적용</p><p>-전국민 고용보험 가입</p><p>-모든 시민 노동3권 보장</p><p>-주 4일제 도입 범시민추진본부 추진, 탄소 배출 많은 사업장에 시범 도입</p>',
            '<p>-지역주도형 청년 일자리 10만개 마련</P><p>-청년 일자리 보상 센터 설립 및 지원</P><p>-무상 취업 교육</P><p>-전국에 청년 심리 치유 센터 설치하고 무료 심리 상담 지원</P>',
            '<p>-청년 일자리 30만개 보장</P><p>-자발적 퇴직자 3회까지 구직 급여 지급</P><p>-비정규직 노동자 평등 수당 지급</P><p>-프리랜서 플랫폼 노동권, 소상공인·예술인 노동권 보장</P><p>-임금 체불 강력 대응하고 1년 이하 근무자 퇴직금 지급</P>',
            '<p>-국민 최저 소득 월 100만 원 보장</p><p>-실시간 소득파악체제를 통한 국민 소득 보험 도입</p>',
            '<p>-</p>',
            '<p>-</p>',
            '<p>-연간 본인 부담 병원비 100만원 상한 제도, 국가 대납 제도 등 돌봄 시민 권리 확대</P><p>-영 케어러’(Young Carer), 재가 간병인 국가 무상 지원</P><p>-노인 일자리ㆍ주거ㆍ소득 등 관리하는 노인복지청 신설</P><p>-장애인 등록제 폐지, 장애인권리 보장법 제정, 장애인 완전 탈시설 등 7대 장애인 공약 제시</P><p>-여성가족부→성평등부 격상</P><p>-비동의 강간죄 도입 등 성폭력 근절 위한 5대 공약 제시 </P><p>-성별 임금 격차 해소법 제정 등 성평등 일터 조성</P><p>-동물 건강 보험 도입, 개 식용 금지하고 동물 번식장 폐쇄, 동물 학대 처벌 강화</P><p>-공공주택 200만 채 공급, 최저 주거 공간 7.5평 설정</P><p>-무주택자 주거비 지원, 세입자 거주권 무제한 연장</P>',
          ],
        },
        {
          id: '4',
          promise: [
            '<p>-과학 기술 통해 세계 5대 경제 강국 진입</P><p>-성장과 복지 선순환하는 구조 조성</P><p>-정부는 기업 간섭과 규제·감시 멈추고 시장 공정성과 사회적 안전망 만드는 일에 집중</P>',
            '<p>-초격차 과학 기술 5개 확보해 5개 글로벌 기업 창출, 세계 5대 경제 강국 진입</p>',
            '<p>-비정규직의 정규직화 아닌 대접받는 비정규직 안착</p>',
            '<p>-</p>',
            '<p>-최저임금 급격하게 올리면 중소 기업 얽매, 정부 손떼야</p>',
            '<p>-정부 투명성 강화해 필요한 만큼 국민 동의 구한 후 증세</p>',
            '<p>-복지 사각지대에 있는 비수급 빈곤층과 코로나19 피해자 집중 복지 시스템 제공</p>',
          ],
        },
      ],
    },
    {
      title: '경제·노동',
      list: ['가계 부채', '법인세', '부동산 보유세', '재벌 개혁', '코로나 경제 활성화', '연금'],
      promise: [
        {
          id: '1',
          promise: [
            '<p>-부동산 전담 기구 설치</p><p>-임대차 3법 안착 </p><p>-대출·부담제한 총량 유지</p>',
            '<p>-</p>',
            '<p>-분양가 상한, 분양 원가 공개, 후분양 제도 도입 </p><p>-거래세 하향·보유세 상향 </p><p>-다주택자 양도세 한시적 완화 검토, 양도세 중과 유예 </p><p>-일시적 2주택자 구제, 1주택 장기보유 저소득층 보호</p><p>-공시가 관련 제도 전면 재검토</p>',
            '<p>-부자 감세 반대</p>',
            '<p>-저금리로 1000만 원 대출할 수 있는 기본대출권 추진 </p><p>-일반 예금보다 높은 금리로 500~1000만 원 기본저축권 추진</p>',
            '<p>-조세 감면분 순차 축소, 토지세·탄소세 등 긴급 교정 과세로 기본소득 재원 마련 </p>',
          ],
        },
        {
          id: '2',
          promise: [
            '<p>-신혼부부·청년·무주택자 LTV 최대 80%까지 상한</p><p>-가계 대출 하향 안정화 위해 대출자 상환 가능성 평가·원리금 분할 상환 방식 의무화</p><p>-보금자리론과 같은 서민 금융 상품 위축되지 않도록 설계</p><p>-가계 부채 부실이 금융 시스템 리스크로 번지지 않도록 은행 자본금 적립 강화하는 등 경기 대응 완충 자본 도입</p>',
            '<p>-역외 기업 국내 유치 위해 법인세 인하 필요</p>',
            '<p>-종부세·재산세 통합</p><p>-1주택자에 한해 면제 검토 1세대 1주택자 세율 인하</p><p>-장기 보유 고령층 1세대 1주택자 납부 유예</p><p>-다주택자 중과세율 적용 한시적으로 배제, 주택 매각 추진</p><p>-공시가격 인상 속도 낮춰 보유세 급증 방지 </p><p>-2022년 주택 가격 2020년 수준으로 환원 </p><p>-취득세 부담 인하</p><p>-정부 출범 즉시 부동산 세제 정상화 위해 TF 가동 </p>',
            '<p>-</p>',
            '<p>-사회 재건을 위한 기금 50조 원 이상 조성</p><p>-비과학적 방역 패스 철회</p>',
            '<p>-</p>',
          ],
        },
        {
          id: '3',
          promise: [
            '<p>-</p>',
            '<p>-</p>',
            '<p>-1가구 1주택 원칙</P><p>-토자 소유 현황 정기적 공개, 농지 투기 근절</p><p>-공공 주택 비중 20% 유지</p><p>-수도권 공공 주택 최대 25만 호 공급</P> <p>-도시주택부·공공주택위원회 설치</P><p>-전월세 임차인 계속 거주권 보장</p><p>-종부세 기능 정상화</P>',
            '<p>-</p>',
            '<p>-</p>',
            '<p>-</p>',
          ],
        },
        {
          id: '4',
          promise: [
            '<p>-기준금리 수준의 45년 초장기 모기지 도입</P><p>-청년·생애최초 주택구입자·장기 무주택자에게 LTV 80% 15년 거치 30년 상환 대출 제공</P><p>-소상공인·자영업자 대출 만기연장·상환유예 촉구</P><p>-실수요자 규제 최소화</P>',
            '<p>-부가세·소득세·법인세에 중앙정부와 지방정부 간 차등 공동세 도입</p>',
            "<p>-현 정부는 '미친 집값, 미친 세금' 만들어, 검토 필요</P><p>-보유세 높이고 양도세와 같은 거래세 낮춰 매물 유도</P>",
            '<p>-음서제도 타파 및 기회 공정 보장</p><p>채용 청탁 및 고용 세습 발각 시 취용 취소, 관련자 엄벌</p>',
            '<p>-백신 패스와 영업 시간 제한 이중 규제 완화, 소상공인 과징금 축소</P><p>-코로나19 특별 회계 신설해 피해 큰 자영업자와 소상공인 집중 지원</P><p>-피해 지원 위해 국채 발행하기보다 기존 예산으로 운용, 예산 구조 조정해서 재원 확보해야</P>',
            '<p>-국민연금·공무원연금·군인연금 등 통합해 동일연금제 추진</P><p>-정부 투명성 강화한 후 국민에게 증세 동의 구해야</P>',
          ],
        },
      ],
    },
    {
      title: '사회·복지',
      list: ['아동 수당', '보육 정책', '육아 휴직', '누리과정 예산', '의료', '코로나 피해 지원'],
      promise: [
        {
          id: '1',
          promise: [
            '<p>-아동 급식 카드 사용처 확대, 아동 급식 지원 단가 인상 등 아동 급식 사업 개선 </p>',
            '<p>-초등학생 오후 3시 동시 하교제, 오후 7시까지 돌봄교실 운영</p><p>-공공어린이집 이용 아동 비율 50% 이상 확대</p><p>-어린이집·유치원 처우 및 시설 개선</p><p>-아동학대 법적 처벌 강화</p><p>-임신 근로자 노동 환경 개선</p><p>-영유아 발달 지원 서비스 전국 확대</p><p>-한부모 가족 증명서 소득 기준 삭제, 한부모 아동 양육비 중위 소득 80%로 확대 </p><p>-국공립유치원 통학 버스 확대하고 병설유치원, 초등 저학년생도 함께 이용하도록 지원</p>',
            '<p>-출산 휴직 자동등록제</p><p>-50인 미만 사업체 임신노동자 대체 인력 인건비 지원 </p><p>-육아휴직 소득 대체율 상향</p><p>-남녀 육아 휴직 확대</p><p>-유보 통합 추진</p>',
            '<p>-대통령 직속 기본소득위 설치 </p><p>-기본소득 전국민 월 100만 원, 청년 월 200만 원 가능한 범위 선 실시 </p><p>-청년 장기 저리 1000만 원 기본대출 </p><p>-일하는 노인에 대한 노령 연금 감액 단계적 조정</p>',
            '<p>-어르신 방문 간호·의료 전국 확대 </p><p>-간호·간병 통합 돌봄 서비스 지역 격차 해소 </p><p>-경제 활동 인구 전체 대상 보편 상병 수당 지급 </p><p>-건강보험공단에 특별 사법경찰권 부여, 불법 근절 전담 조직 설치</p><p>- HPV 백신 남녀·모든 청소년 무료접종 실시</p><p>-간호법 제정 적극 추진 </p><p>-타투 합법화 </p><p>-탈모 치료 건강 보험 적용 확대</p>',
            '<p>-소상공인 온전한 보상, 선지원</p><p>-지역화폐 확대 </p><p>-소상공인·자영업자 전담 차관 신설 </p><p>-배닽특급 서비스 전국 확장 </p><p>-디지털 금융 범죄 범부처 모니터링 시스템 구축 </p><p>-재난 의료비·간병비 지급액 5000만 원 상향</p>',
          ],
        },
        {
          id: '2',
          promise: [
            '<p>-만 0세에서 2세까지 가정양육수당 30만원으로 인상</p><p>-출산 후 1년간 부모 급여 매월 100만 원 정액 지급</p>',
            '<p>-교사대 아동 비율 줄여 보육의 질 개선</p><p>-유보통합 1단계로 만 5세 전면 무상 보육 실시</p><p>-공원 어린이집 도입 등 시설 환경 개선</p><p>-육아 중인 노동자 재택 근무 선택권 부여</p><p>-육아 재택 허용 기업 인센티브 부여</p>',
            '<p>-부모 각각 1.5년 씩 총 3년으로 육아휴직 확대 </p><p>-근로시간 단축 청구권 사용할 수 있는 환경 조성 </p><p>-육아휴직 활용 기업 인센티브 강화, 인프라 조성 </p>',
            '<p>-공적연금개혁위원회 설치</p><p>-특수직역 공무원 연금·일반 연금 병합 문제 논의 </p><p>-노인연금·기초연금 건실화</p>',
            '<p>-백신부작용 국민 신고 센터 설치 </p><p>-정부가 코로나 백신 인과성 증명 책임</p><p>-공공의료기관 전담 병원으로 전환, 공공 건물 신축해 병상 확보 </p><p>-재택 치료 원칙 전면 개편</p><p>-응급환자용 닥터 헬기 확충 </p><p>-당뇨병 환자 연속 혈당 측정기 건보 적용 확대 </p><p>-영문 PCR 검사, 보건소 최소 비용 발급</p>',
            '<p>-코로나 긴급 구조 특별 본부 설치</p> <p>-기존 대출금 만기 연장</p><p>-적극적인 세제, 금융 지원으로 기존 지원 제도 사각지대 해소</p><p>-코로나 손실 지수화·표준화·형태화 해 피해 정도에 따라 보상 기금 균등 배분</p><p>-50조 원 규모 코로나 손실 보상 기금 만들고 오미크론 변이 확산에 따라 기존 제한 완화</p>',
          ],
        },
        {
          id: '3',
          promise: [
            '<p>-아동 수당 만 11세까지 대상 확대</p><p>-임산부·영유아 방문 건강제</p><p>-아동학대 전담 공무원, 아동 심리 상담가 배치해 아동 자살 방지 대책 확보</p><p>-학대 아동 쉼터, 가정 위탁 지원</P>',
            '<p>-</p>',
            '<p>-온 사회가 함께 키우는 사회적 돌봄 체계 구축</p><p>-육아휴직 급여 현실화</p><p>-육아휴직 아빠 할당제</p><p>-자동 육아 휴직 법제화</p><p>-출산휴가 120일, 배우자 출산 휴가 30일로 확대</p><p>-전국민 육아휴직제</p><p>-육아휴직 대체 인력 지원</p>',
            '<p>-아동 수당을 아동 청소년 수당으로 확대</p><p>-저소득층 노인 생활에 적절한 수준으로 기초 연금 인상</P>',
            '<p>-간호 인력 확충·의료인 생명 안전 수당 추진</P><p>-공공 병원 확충·역할 강화</p><p>-권역별 감염 전문 병원 7개소 설립</p>',
            '<p>-코로나19 피해 자영업자 부채 이자 탕감</p><p>-고위험군 자영업가구 파산 방지 위해 100% 손실 보장 등 신용 회복 특별 트랙 마련</P><p>-플랫폼 기업 골목 상권 갑질 방지</p><p>-방역 패스 검사 인력 지원, 검사 거부자 처벌 규정 마련</P>',
          ],
        },
        {
          id: '4',
          promise: [
            '<p>-아이 돌보는 조부모에게 아이 한 명당 월 20만 원 지급</p>',
            '<p>-방과 후 7시까지 코딩, 영어 회화 등 배우는 전일제 학교 운영</p> <p>-국공립어린이집 아동수 대비 70%까지 확대</p>',
            '<p>-</p>',
            '<p>-중위소득 40% 이하 복지 사각지대 해소</P> <p>-생계급여 부양의무자 기준 완전 폐지</P><p>-근로 장려 제도 강화해 탈수급 유도</P><p>-고의 증여 수급 사전 방지</P><p>-국민연금 개혁, 공적 연금 일원화</P><p>-연금 개혁 관련 보험료율 인상은 피할 수 없어, 최소한 소득대체율 40%선 유지</P>',
            '<p>-의료급여 부양의무자 기준 완전 폐지</P><p>-경증 과다 이용자 불이익 기준 제시</P><p>-의료수가 일부에 대한 합리적 조정 방안 강구</P><p>-2023년까지 환자 대 간호사 비율 제도화</P><p>-2026년까지 간호 간병 통합 서비스 전면 시행</P><p>-2023년까지 PA 무면허 불법 의료 근절, 의료 인력 업무 범위 명확화</P><p>-야간 교대 근무제 전면 개선, 보상 강화해 간호사 이직율 축소</P>',
            '<p>-코로나19 특별 회계로 매년 30조 원 재정 확보</p><p>-정부 지출·인력 구조 조정</p><p>-민관 합동 조세 특례 평가 위원회로 조세감면 정비</p><p>-한시적으로 가칭 코로나19퇴치복권 발행</p>',
          ],
        },
      ],
    },
    {
      title: '교육',
      list: ['대입 정책', '외고∙자사고∙국제고', '교육부 개혁'],
      promise: [
        {
          id: '1',
          promise: ['<p>-</p>', '<p>-</p>', '<p>-</p>'],
        },
        {
          id: '2',
          promise: [
            '<p>-대학 입시 제도 단순화, 정시 비율 확대 조정 </p><p>-입시 비리 암행어사제, 입시 비리 원스트라이크아웃제 도입 </p><p>-지역별 교육 훈련 격차 해소 위해 청년 도약 디지털 스쿨 설치 </p><p>-수능 응시료, 입학 전형료 세액 공제 적용</p>',
            '<p>-</p>',
            '<p>-교육부 간섭 축소 </p>',
          ],
        },
        {
          id: '3',
          promise: ['<p>-</p>', '<p>-</p>', '<p>-</p>'],
        },
        {
          id: '4',
          promise: [
            '<p>-수능 2회 실시</p><p>-일반전형 80%, 특별전형 20% 포함한 정시 100% 유지</p><p>-민주화운동유공자 자녀 특별전형 등 사회적 합의와 공정 경쟁 없는 전형 폐지</p><p>-로스쿨과 고시제도 병행</p><p>-의학전문대학원 폐지</p>',
            '<p>-특목고 폐지 전면 백지화</P><p>-취약 계층 학생에게 특목고 교육 기회, 지원 확대</P>',
            '<p>-교육부 지원 기능 총리실 산하로 이전</p><p>-거시적이고 장계적인 계획 국가교육위원회에서 사회적 공론화</p>',
          ],
        },
      ],
    },
    {
      title: '환경',
      list: ['미세먼지 국내 해외', '미세먼지 비교', '탄소 배출'],
      promise: [
        {
          id: '1',
          promise: [
            '<p>-</p>',
            '<p>-현행 미세먼지 계절관리제 개선 및 심화 </p><p>-소규모 영세 사업장의 배출 저감 지원 확대 </p><p>-미세먼지 실시간 관측 가능한 스마트 클린 도시 확대 조성</p',
            '<p>-2050 탄소중립 달성</p><p>-에너지 고속도로 신설  </p><p>-기후에너지부 신설 </p><p>-탄소세 도입</p><p>-전기차 360여만 대 보급, 보조금 확대</p><p>-플라스틱 제로 사회로 전환 </p><p>-신한울 3·4호기 원전 재개 검토 </p><p>-주요 생활 용품 소모성 부품 보유 및 판매 기간 늘려 생활 용품 수명 연장</p>',
          ],
        },
        {
          id: '2',
          promise: [
            '<p>-탈 원전 백지화, 원전 비중 확대, 탈 석탄으로 미세 먼지 감축</p><p>-전국 초등학교에 미세먼지 정화기 설치</p><p>-미세먼지 경보 2일 전 발령</p>',
            '<p>-</p>',
            '<p>-원자력 조화한 탄소 중립 추진</p><p>-신한울 3·4호기 원전 재개, 원자력 빌전 비중 30%대 유지</p><p>-한미 원자력 동맹 강화</p><p>-원자력 수출 범정부 추진 조직 구성</p><p>-원전 수출 통한 일자리 10만 개 창출</p> <p>-임기 내 화석 연료 발전 비중 1/3로 감축, 미세먼지 30% 이상 감축</p><p>-재생 에너지와 원전 발전 비중 확대</p><p>-탄소중립은 과학 기술 더 발전해야 도달 가능, 2030 온실가스 40% 감축 목표 로드맵 통해 수치 결정</p>',
          ],
        },
        {
          id: '3',
          promise: [
            '<p>-</p>',
            '<p>-</p>',
            '<p>-구해줘 지구 5050 플랜 도입, 10대 과제 추진</p><p>-국가기후비상회의 설립</P><p>-2030년 탄소 배출 50% 감축 법제화</p><p>-2030년 석탄 화력 발전 종료</p><p>-2030년 내연 기관차 판매 금지</p><p>-GDP 2%를 기후 위기 녹색 전환에 투자</P>',
          ],
        },
        {
          id: '4',
          promise: ['<p>-</p>', '<p>-</p>', '<p>-혁신형 중소형모듈원전으로 원자력 산업 수출 경쟁력 강화 및 탄소중립 실현</p>'],
        },
      ],
    },
    {
      title: 'IT',
      list: ['산업 구조 개편', '신산업 분야', '창업 지원'],
      promise: [
        {
          id: '1',
          promise: [
            '<p>-갑·을 관계 시정해 공정거래 질서 확보</p> <p>-소멸 위기 지역 중심으로 휴식·관광 연계 할 수 있는 워케이션 센터 설치</p><p>-공인 탐정 자격증 제도 도입</p>',
            '<p>-기초·첨단 과학 기술 투자 </p><p>-기후에너지부, 우주산업전략본부, 데이터전담부 설치 </p><p>-과학기술혁신 부총리제 도입 </p><p>-1조원 규모 지역 자율 R&D 예산 확보 </p><p>-사물인터넷(IoT), 클라우드, 5G/6G위성 통신 3대 인프라 구축</p><p>-전 국민 디지털 주권 보장, 마이데이터 제도 확장</p><p>-2027년 까지 벤처 투자 예산 10조 원 확대 </p><p>-국방 우주 네트워크 구축</p>',
            '<p>-재기 지원 펀드 </p><p>-상생 협력금 등을 늘려 재창업 지원 </p><p>-스타트업 특허 심사 3개월로 단축, 우대 심사 확대</p>',
          ],
        },
        {
          id: '2',
          promise: [
            '<p>-저성장 극복하기 위해 산업 구조 고도화, 산업 전략 재편 필요</p><p>-4차 산업혁명에서 첨단 기술 선도하고 디지털 데이터 인프라 확중해 경제 사회 전반의 제도와 문화 혁신</p>',
            '<p>-신성장 동력 첨단 분야·현장 기능 분야로 나누어 맞춤형 인재 양성</p><p>-국제 경쟁력 기대할 수 있는 중소기업에 재정 지원·자금 중개 기능 강화</p><p>-비대면, 의료, 문화 콘텐츠 분야 유니콘 기업 50여 개 육성</p><p>-불필요한 규제 완화해 온라인 게임 쉽게 즐길 수 있는 나라 추구</p> <p>-확률형 아이템 정보 완전 공개, E스포츠 지역 연고제 도입 등 게이머가 우선인 나라 추구</p><p>-인공지능 산업 육성, 소프트웨어 산업 발전</p><p>-5G, 6G, 마이데이터, 민간 클라우드 등 디지털 인프라 구축</p><p>-마이데이터 산업 활성화, 반도체 모빌리티 등 디지털 융합 산업 지원</p><p>-사이버 안전망 구축 </p><p>-100만 디지털 인재 양성</p>',
            '<p>-중원 신산업벨트와 인근대학·연구소를 청년 창업 기지로 활용 </p><p>-스타트업 천국 대한민국 </p>',
          ],
        },
        {
          id: '3',
          promise: [
            '<p>-10년 내 녹색 경제 대전환</p><p>-2023년 신차 통학 차량 100% 전기차 공급</p><p>-한전발전 자회사를 재생에너지공사로 통합</p><p>-지역 공동체 재생 에너지 투자법 마련</p><p>-1가구 1태양광 시대 추진</P>',
            '<p>-소형 위성을 기반으로 차세대 통신을 구현하는 소우주 전략 추진</P><p>-강원도를 녹색평화경제특별도로 승격, 국립재생에너지연구소 설립</P><p>-국가우주청 신설</P><p>-가상 자산 시장 제도화</P><p>-가상 자산 악용 막기 위해 특정금융정보법, 트래블룰 규제 준수</P>',
            '<p>-</p>',
          ],
        },
        {
          id: '4',
          promise: [
            '<p>-5개 초격차 기술로 5개 글로벌 기업 만들어 5대 경제 강국 진입</p><p>-국가 및 공공기관 데이터 개방</p><p>-R&D 예산 GDP 5% 확대</p><p>-2조원 규모 초격차펀드 조성</p><p>-기술 인력 이민제 도입</p><p>-국무총리 직속 규제혁신처 신설</p>',
            '<p>-R&D 예산 GDP 5% 확대</P><p>-2조원 규모 초격차펀드 조성</P> <p>-국무총리 직속 규제혁신처 신설</P><p>-특정 부분 금지하고 자유 보장하는 네거티브 규제 개혁</P>',
            '<p>-중소기업부에서 스타트업 특허 지원</p><p>-스타트업 특허 컨트롤타워, 과학기술 부총리 관할</p>',
          ],
        },
      ],
    },
    {
      title: '개헌·개혁',
      list: ['개헌', '검찰개혁'],
      promise: [
        {
          id: '1',
          promise: ['<p>-</p>', '<p>-</p>'],
        },
        {
          id: '2',
          promise: [
            '<p>-헌법적 대통령제로 대통령의 초법적 지위 헌법과 법률의 틀로 규정 </p><p>-민정수석실 폐지 </p>',
            '<p>-공수처 폭주 제재</p><p>-공수처 대대적인 개편과 개혁 필요</p>',
          ],
        },
        { id: '3', promise: ['<p>-</p>', '<p>-</p>'] },
        {
          id: '4',
          promise: [
            '<p>-4년 중임 분권형 대통령제 추진</P><p>-대통령 권한 과다하고 견제 세력 없어, 청와대 규모 반으로 축소</P>',
            '<p>-현재 경찰 권한 과도해, 검경 견제와 균형 가능하도록 할 것</p>',
          ],
        },
      ],
    },
  ],
];
